import AjaxPromises from '../utils/AjaxPromises';
import AppDispatcher from '../utils/AppDispatcher';
import UserStore from '../stores/UserStore';
var keyMirror = require('keymirror');

const actions = keyMirror({
    LOADED_ALL_REFERENCE_DATA: null,
});

export default {
    actions,
    loadAll() {
        AjaxPromises.POST('api/ReferenceData/get-all', UserStore.getApiData()).then((resp) => {
            if (resp.Result) {
                AppDispatcher.dispatch({
                    actionType: actions.LOADED_ALL_REFERENCE_DATA,
                    data: resp.Data,
                });
            }
        });
    },
};



// WEBPACK FOOTER //
// ./ui_src/app/actions/ReferenceDataActions.jsx